import React from 'react'
import { InfoBox } from 'src/components/InfoBox'
import { getReadableNumber } from 'src/helpers/getReadableNumber'
import { Synth } from 'src/services/GraphService'

interface IProps {
  synth?: Synth
  currentLiquidationPrice: string
  currentPrice: string
  currentCollateralRatio: string
  minimumCollateralRatio: string
}

export function ManageInfo({
  currentLiquidationPrice,
  synth,
  currentPrice,
  currentCollateralRatio,
  minimumCollateralRatio,
}: IProps) {
  return (
    <InfoBox
      infos={[
        {
          property: 'Current Price',
          tooltip: 'Current price of one token to be deposited',
          value: `$${currentPrice}`,
        },
        {
          property: 'Collateral Ratio',
          tooltip: 'Collateral value / loan amount',
          value: `${currentCollateralRatio}%`,
        },
        {
          property: 'Minimum Ratio',
          tooltip:
            'You cannot borrow an amount that<br /> has a collateral ratio lower than this number.',
          value: `${minimumCollateralRatio}%`,
        },
        {
          property: 'Liquidation Price',
          tooltip:
            'If the current price falls below this value,<br /> you will be subject to the liquidation penalty below.',
          value: `$${currentLiquidationPrice}`,
        },
        {
          property: 'Liquidation Penalty',
          tooltip: 'Penalty applied to the collateral if the position is liquidated.',
          value: `${getReadableNumber(synth.liquidationUserFee?.mul(100), 2)}%`,
        },
        {
          property: 'Interest Rate',
          value: `${getReadableNumber(synth.interestRate?.mul(100))}%`,
        },
      ]}
    />
  )
}
